'use strict';

const {Unit} = require("../../custom_components/js/unit/Unit");

module.exports = (app) => app.factory('unitService', /* @ngInject */ function (apiConfig, httpService, translationService) {

    /**
     * @type {Unit[]}
     */
    let units;

    /**
     *
     * @return Promise<{{unece: string, name: string}[]}>
     */
    function fetch() {
        const uri = apiConfig.getBase('unit', 'active');

        return httpService.get(uri.toString(), {
            cache: true,
            isArray: true
        })
    }

    async function getAll() {
        if(!units) {
            const fetchedUnits = await fetch();
            units = fetchedUnits.map(unit => new Unit(unit.unece, unit.name, translationService));
        }

        return units;
    }

    async function getByUnece(unece) {
        const units = await getAll();
        const unit = units.find(u => u.unece === unece);
        if(unit) {
            return unit;
        }

        return new Unit(unece, unece, translationService);
    }

    return {
        /**
         * @returns Promise<Unit>
         */
        getByUnece
    }

});
